import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect } from "react";
import routes from "./config";

let navigateResolver: ((navigate: NavigateFunction) => void) | null = null;
let isNavigateResolved = false;

declare global {
  interface Window {
    REACT_APP_NAVIGATE?: NavigateFunction;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = (navigate) => {
    if (isNavigateResolved) return;
    isNavigateResolved = true;
    resolve(navigate);
  };
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();

  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver?.(navigate);

    return () => {
      if (window.REACT_APP_NAVIGATE === navigate) {
        delete window.REACT_APP_NAVIGATE;
      }
    };
  }, [navigate]);

  return element;
}
